import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-field p-m-2" }
const _hoisted_2 = { class: "p-float-label" }
const _hoisted_3 = { class: "kn-material-input-label" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 4 }
const _hoisted_7 = { key: 5 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Chip = _resolveComponent("Chip")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    contentStyle: _ctx.metadataDefinitionTabViewDescriptor.dialog.style,
    header: _ctx.$t('kpi.measureDefinition.saveInProgress'),
    visible: true,
    modal: true,
    class: "p-fluid kn-dialog--toolbar--primary",
    closable: false
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--secondary",
        label: _ctx.$t('common.close'),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
      }, null, 8, ["label"]),
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        label: _ctx.$t('common.save'),
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('save', _ctx.name))),
        disabled: _ctx.saveRuleButtonDisabled
      }, null, 8, ["label", "disabled"])
    ]),
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("span", _hoisted_2, [
          _createVNode(_component_InputText, {
            class: "kn-material-input",
            type: "text",
            modelValue: _ctx.name,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.name = $event)),
            modelModifiers: { trim: true }
          }, null, 8, ["modelValue"]),
          _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('common.name')), 1)
        ])
      ]),
      (_ctx.newAlias.length > 0 || _ctx.reusedAlias.length > 0)
        ? (_openBlock(), _createBlock(_component_Toolbar, {
            key: 0,
            class: "kn-toolbar kn-toolbar--primary"
          }, {
            start: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('kpi.measureDefinition.alias')), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.newAlias.length > 0)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode("h4", null, _toDisplayString(_ctx.$t('common.new')), 1),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.newAlias, (alias) => {
              return (_openBlock(), _createBlock(_component_Chip, {
                class: "p-m-2",
                key: alias.id,
                label: alias
              }, null, 8, ["label"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.reusedAlias.length > 0)
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            _createVNode("h4", null, _toDisplayString(_ctx.$t('common.reused')), 1),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.reusedAlias, (alias) => {
              return (_openBlock(), _createBlock(_component_Chip, {
                class: "p-m-2",
                key: alias.id,
                label: alias
              }, null, 8, ["label"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.newPlaceholder.length > 0 || _ctx.reusedPlaceholder.length > 0)
        ? (_openBlock(), _createBlock(_component_Toolbar, {
            key: 3,
            class: "kn-toolbar kn-toolbar--primary"
          }, {
            start: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('kpi.measureDefinition.placeholder')), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.newPlaceholder.length > 0)
        ? (_openBlock(), _createBlock("div", _hoisted_6, [
            _createVNode("h4", null, _toDisplayString(_ctx.$t('common.new')), 1),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.newPlaceholder, (placeholder) => {
              return (_openBlock(), _createBlock(_component_Chip, {
                class: "p-m-2",
                key: placeholder.id,
                label: placeholder
              }, null, 8, ["label"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.reusedPlaceholder.length > 0)
        ? (_openBlock(), _createBlock("div", _hoisted_7, [
            _createVNode("h4", null, _toDisplayString(_ctx.$t('common.reused')), 1),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.reusedPlaceholder, (placeholder) => {
              return (_openBlock(), _createBlock(_component_Chip, {
                class: "p-m-2",
                key: placeholder.id,
                label: placeholder
              }, null, 8, ["label"]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["contentStyle", "header"]))
}